import { Footer } from './components/Footer'
import { Hero } from './components/Hero'
import Navigation from './components/Navigation'
import { BrowserRouter as Router, useNavigate } from 'react-router-dom'
import ScrollToTop from './util/ScrollToTop'
import { Main } from './components/Main'
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
function App() {
      const [showButton, setShowButton] = useState(false)
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        })
    }, [])
     useEffect(() => {
         const onscroll = () => {
             const scrolledTo = window.scrollY + window.innerHeight
             const isNearBottom = document.body.scrollHeight - scrolledTo <= 300
             if (isNearBottom) setShowButton(false)
         }
         window.addEventListener('scroll', onscroll)
         return () => {
             window.removeEventListener('scroll', onscroll)
         }
     }, [])
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <ScrollToTop />
            <div className='bg-island'>
                <Navigation />
                <Hero />
                <Main />
                <Footer />
            </div>{' '}
            {showButton && (
                <motion.button
                    initial={{
                        opacity: 0,
                        transition: {
                            duration: 1,
                            ease: 'easeInOut',
                        },
                    }}
                    whileInView={{
                        opacity: 1,
                        transition: {
                            duration: 1,
                            ease: 'easeInOut',
                        },
                    }}
                    viewport={{ once: false }}
                    onClick={scrollToTop}
                    className='fixed bottom-2 right-2 md:right-[8px] cursor-pointer z-20 duration-300'
                >
                    <img
                        className='w-2/5 md:w-4/5 ml-auto'
                        src={`${process.env.PUBLIC_URL}/images/btn_sctop.webp`}
                        alt='scroll to top'
                    />
                </motion.button>
            )}{' '}
        </Router>
    )
}

export default App
